/** Reusable toggle bound via getter/setter (works with async x-include partials). */
export function uiSwitch(get, set) {
  const read = typeof get === 'function' ? get : () => get;
  const write = typeof set === 'function' ? set : (v) => { get = v; };
  return {
    switchDisabled: false,
    switchLabel: '',
    get on() {
      return !!read();
    },
    set on(v) {
      write(!!v);
    },
    toggle() {
      if (this.switchDisabled) return;
      this.on = !this.on;
    },
  };
}
